// Причины невалидности workflow
import { ValueOf } from '@workflows/types';

export const REQUEST_WORKFLOW_INVALID_REASON = {
  PRODUCT_DELETED: 'productDeleted',
  PRODUCT_ASSOC_DELETED: 'productAssocDeleted',
  MISSING_REQUEST_CRITERIA_SNAPSHOT: 'missingRequestCriteriaSnapshot',
  REQUEST_MISSING_CONTRACTOR_COUNTERPARTY:
    'requestMissingContractorCounterparty',
  REQUEST_MISSING_COUNTERPARTY_OWNER: 'requestMissingCounterpartyOwner',
  COUNTERPARTY_OWNER_CHANGED: 'counterpartyOwnerChanged',
  CONTRACTOR_COUNTERPARTY_CHANGED: 'contractorCounterpartyChanged',
  REQUEST_HAS_IGNORED_PRODUCT: 'requestHasIgnoredProduct',
} as const;
export type RequestWorkflowInvalidReason = ValueOf<
  typeof REQUEST_WORKFLOW_INVALID_REASON
>;

// Расширенные причины невалидности для product workflow (включает базовые + специфичные)
export const REQUEST_PRODUCT_WORKFLOW_INVALID_REASON = {
  PRODUCT_ASSOC_CHANGED: 'productAssocChanged',
  ...REQUEST_WORKFLOW_INVALID_REASON,
} as const;
export type RequestProductWorkflowInvalidReason = ValueOf<
  typeof REQUEST_PRODUCT_WORKFLOW_INVALID_REASON
>;

// Детали для каждой причины невалидности - указываем только те, у которых есть details
export type InvalidReasonDetailsMap = {
  [REQUEST_WORKFLOW_INVALID_REASON.COUNTERPARTY_OWNER_CHANGED]: {
    requestSnapshotCounterpartyOwnerId: number;
    currentRequestCounterpartyOwnerId: number;
  };
  [REQUEST_WORKFLOW_INVALID_REASON.CONTRACTOR_COUNTERPARTY_CHANGED]: {
    bindingSnapshotContractorCounterpartyId: number;
    currentRequestContractorCounterpartyId: number;
  };
  [REQUEST_WORKFLOW_INVALID_REASON.REQUEST_HAS_IGNORED_PRODUCT]: {
    ignoredProductIds: number[];
    currentProductIds: number[];
  };
};
